import { createFileRoute } from '@tanstack/react-router'
import { InviteStaffPage } from '@/pages/InviteStaffPage'
import {
  fetchCandidateMailTemplate,
  fetchInvitationRoles,
  fetchInvitations,
  fetchMailTemplate,
} from '@/services/api/invitations'
import { requireRoles } from '@/utils/routeGuards.ts'
import { ROUTE_ACCESS } from '@/constants/routeAccess.ts'
import { ROUTES } from '@/constants/routeConstants'

export const Route = createFileRoute('/backoffice/invitations')({
  beforeLoad: requireRoles(ROUTE_ACCESS[ROUTES.INVITE_STAFF]),
  loader: async () => {
    const [
      mailTemplate,
      candidateMailTemplate,
      invitations,
      roleAvailabilities,
    ] = await Promise.all([
      fetchMailTemplate(),
      fetchCandidateMailTemplate(),
      fetchInvitations(),
      fetchInvitationRoles(),
    ])

    return {
      mailTemplate,
      candidateMailTemplate,
      invitations,
      roleAvailabilities,
    }
  },
  component: InviteStaffPage,
})
